import React, { useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth0 } from '@auth0/auth0-react';
import AppContext from '../../lib/contextProviders/contexts/appContext';
import { useUserContext } from '../../lib/contextProviders/contexts/userContext';

const VerifyUserLoggedIn = ({
  children,
  byPassVerificationSiteTypes = [],
  loginRedirectAppState = null,
}) => {
  const [isVerified, setIsVerified] = useState(false);
  const router = useRouter();
  const { loginWithRedirect } = useAuth0();
  const {
    userState: { isLoggedIn, isLoggingIn },
  } = useUserContext();
  const {
    appState: { siteType },
  } = useContext(AppContext);

  useEffect(() => {
    if (isLoggedIn) {
      setIsVerified(true);
    } else if (!isLoggingIn) {
      if (byPassVerificationSiteTypes.includes(siteType)) {
        setIsVerified(true);
      } else {
        loginWithRedirect({
          redirectUri: window.location.origin,
          ...(loginRedirectAppState ? { appState: loginRedirectAppState } : {}),
        });
      }
    }
  }, [
    router,
    loginWithRedirect,
    byPassVerificationSiteTypes,
    isLoggingIn,
    isLoggedIn,
    loginRedirectAppState,
    siteType,
  ]);

  if (!isVerified) {
    return null;
  }

  return <>{children}</>;
};

export default VerifyUserLoggedIn;
